import { isDefined } from '@app/utils/is';
import { IconComponent, Notifications } from '@typings';
import cx from 'classnames';

import { NotificationWrapper } from './NotificationWrapper';

interface Props extends React.PropsWithChildren {
  type: Notifications.NotificationType;
  message: React.ReactNode;
  role?: Notifications.Role;
  isFluid?: boolean;
  dataTestId?: string;
  className?: string;
  icon?: IconComponent;
  isBordered?: boolean;
}

export const Notification = ({ type, role, message, children, ...rest }: Props) => {
  return (
    <NotificationWrapper type={type} role={role} {...rest}>
      <span className="break-words text-neutral-20 body-2">
        <span className={cx({ 'pr-2': isDefined(children) })}>{message}</span>
        {children}
      </span>
    </NotificationWrapper>
  );
};
